import { render } from "./ThongTinChuyenDi.vue?vue&type=template&id=8ed361ba"
import script from "./ThongTinChuyenDi.vue?vue&type=script&lang=js"
export * from "./ThongTinChuyenDi.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__